import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import AdminLayout from './AdminLayout';
import AdminLogin from './pages/AdminLogin';
import Dashboard from './pages/Dashboard';
import BlogList from './pages/BlogList';
import BlogCreate from './pages/BlogCreate';
import BlogEdit from './pages/BlogEdit';
import CareerList from './pages/CareerList';
import CareerCreate from './pages/CareerCreate';
import CareerEdit from './pages/CareerEdit';

import ApplicationList from './pages/ApplicationList';
import ContactList from './pages/ContactList';
import ServiceList from './pages/ServiceList';
import ServiceCreate from './pages/ServiceCreate';
import ServiceEdit from './pages/ServiceEdit';
import TeamList from './pages/TeamList';
import TeamCreate from './pages/TeamCreate';
import TeamEdit from './pages/TeamEdit';
import GalleryList from './pages/GalleryList';
import GalleryCreate from './pages/GalleryCreate';
import FaqList from './pages/FaqList';
import FaqCreate from './pages/FaqCreate';
import TestimonialList from './pages/TestimonialList';
import TestimonialCreate from './pages/TestimonialCreate';
import TestimonialEdit from './pages/TestimonialEdit';
import PrivacyPolicySettings from './pages/PrivacyPolicySettings';

const AdminRoutes = () => {
  const token = localStorage.getItem('token');

  return (
    <Routes>
      {/* Public Route - Login */}
      <Route path="login" element={<AdminLogin />} />

      {/* Protected Routes - Require Authentication */}
      <Route
        path="*"
        element={
          token ? (
            <AdminLayout />
          ) : (
            <Navigate to="login" replace />
          )
        }
      >
        <Route path="dashboard" element={<Dashboard />} />
        
        {/* Blog Routes */}
        <Route path="blogs" element={<BlogList />} />
        <Route path="blogs/create" element={<BlogCreate />} />
        <Route path="blogs/edit/:id" element={<BlogEdit />} />
        
        {/* Career/Job Routes */}
        <Route path="careers" element={<CareerList />} />
        <Route path="careers/create" element={<CareerCreate />} />
        <Route path="careers/edit/:id" element={<CareerEdit />} />

        
        {/* Application Routes */}
        <Route path="applications" element={<ApplicationList />} />
        
        {/* Contact Routes */}
        <Route path="contacts" element={<ContactList />} />
        
        {/* Service Routes */}
        <Route path="services" element={<ServiceList />} />
        <Route path="services/create" element={<ServiceCreate />} />
        <Route path="services/edit/:id" element={<ServiceEdit />} />
        
        {/* Team Routes */}
        <Route path="team" element={<TeamList />} />
        <Route path="team/create" element={<TeamCreate />} />
        <Route path="team/edit/:id" element={<TeamEdit />} />
        
        {/* Gallery Routes */}
        <Route path="gallery" element={<GalleryList />} />
        <Route path="gallery/create" element={<GalleryCreate />} />
        
        {/* FAQ Routes */}
        <Route path="faqs" element={<FaqList />} />
        <Route path="faqs/create" element={<FaqCreate />} />

        {/* Testimonial Routes */}
        <Route path="testimonials" element={<TestimonialList />} />
        <Route path="testimonials/create" element={<TestimonialCreate />} />
        <Route path="testimonials/edit/:id" element={<TestimonialEdit />} />

        {/* Privacy Policy settings */}
        <Route path="privacy-policy" element={<PrivacyPolicySettings />} />
        
        {/* Default redirect to dashboard */}
        <Route path="" element={<Navigate to="dashboard" replace />} />
      </Route>

      {/* Redirect root to dashboard if logged in, else to login */}
      <Route
        path=""
        element={
          token ? (
            <Navigate to="dashboard" replace />
          ) : (
            <Navigate to="login" replace />
          )
        }
      />
    </Routes>
  );
};

export default AdminRoutes;
